<template>
  <BRow>
    <BCol
      cols="12"
    >
      <div
        class="d-flex flex-column flex-md-row justify-content-between flex-grow-1 gap-2"
      >
        <div>
          <div
            class="d-flex gap-2"
          >
            <BButton
              v-if="tableMemos.selected.details.length <= 0"
              v-b-tooltip.hover.bottomright="{ variant: 'success' }"
              title="Select All"
              size="sm"
              :variant="tableMemos.rows.length <= 1 ? 'outline-dark' : 'outline-success'"
              class="text-nowrap"
              :disabled="tableMemos.rows.length <= 1"
              @click.prevent="$event => selectCustomers(true)"
            >
              <i class="fa-lg fad fa-list-check pr-0" />
            </BButton>
            <BButton
              v-else-if="tableMemos.selected.details.length > 0"
              v-b-tooltip.hover.bottomright="{ variant: 'warning' }"
              title="Unselect All"
              size="sm"
              variant="outline-warning"
              class="text-nowrap"
              @click.prevent="$event => selectCustomers(false)"
            >
              <i class="fa-md fad fa-align-slash pr-0" />
            </BButton>
            <BButton
              v-b-tooltip.hover.bottomright="{ variant: 'danger' }"
              title="Remove All Selected"
              size="sm"
              :variant="tableMemos.selected.details.length <= 0 ? 'outline-dark' : 'outline-danger'"
              class="text-nowrap"
              :disabled="tableMemos.selected.details.length <= 0"
              @click.prevent="$event => removeCustomers()"
            >
              <i class="fa-lg fad fa-trash-can pr-0" />
            </BButton>
            <slot name="table-actions" />
          </div>
        </div>
        <div
          class="d-flex align-self-end pb-2 order-1 order-md-2"
          style="column-gap: 5px; row-gap: 5px;"
        >
          <div>
            <BInputGroup
              size="sm"
            >
              <BFormInput
                v-model="additional"
                class="text-right min-w-75px max-w-100px"
                placeholder="0"
                type="number"
                min="1"
                max="25"
                step="1"
                size="sm"
              />
              <BInputGroupAppend>
                <BButton
                  size="sm"
                  variant="outline-dark"
                  class="min-w-45px"
                  @click.prevent="() => addMemo(additional)"
                >
                  +
                </BButton>
              </BInputGroupAppend>
            </BInputGroup>
          </div>
          <div
            class="d-flex"
            style="column-gap: 5px; row-gap: 5px;"
          >
            <BButton
              size="sm"
              variant="outline-dark"
              class="min-w-45px"
              @click.prevent="$event => addMemo(5)"
            >
              +5
            </BButton>
            <BButton
              size="sm"
              variant="outline-dark"
              class="min-w-45px"
              @click.prevent="$event => addMemo(10)"
            >
              +10
            </BButton>
          </div>
        </div>
      </div>
    </BCol>

    <BCol
      cols="12"
    >

      <ValidationObserver
        ref="formMemos"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <BTable
            ref="tableMemos"
            small
            hover
            striped
            bordered
            responsive
            show-empty
            class="mb-0 px-0"
            sticky-header="calc(100vh - 16.4rem)"
            :items="tableMemos.rows"
            :busy="tableMemos.busy || fetching"
            :filter="tableMemos.filter"
            :fields="tableMemos.fields"
            :stacked="tableMemos.stacked"
            :filter-included-fields="tableMemos.filterOn"
            @row-contextmenu="tableRowRightClick"
          >

            <template #head(selected)>
              <BFormCheckbox
                v-model="tableMemos.selected.allSelected"
                :indeterminate="(tableMemos.selected.indeterminate)"
                :disabled="(tableMemos.busy || tableMemos.rows.length <= 1)"
                size="lg"
                tabindex="-1"
                @change="selectCustomers"
              />
            </template>

            <template #cell(index)="{ index }">
              <div
                class="text-md-nowrap d-flex justify-content-center align-items-centermin-h-35px"
                v-text="tableRowNumber(tableMemos, index)"
              />
            </template>

            <template #cell(selected)="{ index }">
              <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                <BFormCheckbox
                  v-model="tableMemos.selected.details"
                  :disabled="(tableMemos.busy || tableMemos.rows.length <= 1)"
                  :value="index"
                  size="lg"
                  tabindex="-1"
                />
              </div>
            </template>

            <template #cell(action)="{ item, index }">
              <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                <BButton
                  :disabled="(tableMemos.busy || tableMemos.rows.length <= 1)"
                  :variant="tableMemos.rows.length <= 1 ? 'outline-dark' : 'outline-danger'"
                  class="border-0"
                  tabindex="-1"
                  @click.prevent="() => removeCustomer(item, index, false)"
                >
                  <i class="fa-lg fad fa-trash-can pr-0" />
                </BButton>
              </div>
            </template>

            <template #cell(officer)="{ item, index }">
              <div class="text-md-nowrap">
                <FSOfficer
                  v-model="item.officer"
                  :index="index"
                  :fetching="fetching"
                  :options="filterOfficers(item)"
                  @input="value => updateFsoCluster(value, item)"
                />
              </div>
            </template>

            <template #cell(officer.clusters)="{ item }">
              <BFormSelect
                id="fIsSigned"
                v-model="item.cluster"
                text-field="cluster_name"
                value-field="id"
                :options="item.officer?.clusters || []"
              >
                <template #first>
                  <BFormSelectOption
                    value=""
                    disabled
                    v-text="' - - select here - - '"
                  />
                </template>
              </BFormSelect>
            </template>

            <template #cell(customer)="{ item, index }">
              <div class="text-md-nowrap">
                <Customer
                  v-model="item.customer"
                  :index="index"
                  :item="item"
                  :rows="tableMemos.rows"
                />
              </div>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <BIcon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </BTable>
        </form>
      </ValidationObserver>
    </BCol>
  </BRow>
</template>
<script>
import Customer from '@/views/asm/customer-memos/components/memo-table/Customer.vue'
import FSOfficer from '@/views/asm/customer-memos/components/memo-table/FSOfficer.vue'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

export default {
  name: 'ASMCustomerMemosMultipleTable',

  components: {
    Customer,
    FSOfficer
  },

  mixins: [
    MISC,
    FORMATTER
  ],

  props: {
    fetching: {
      type: Boolean,
      required: false,
      default: () => false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    details: {
      type: Array,
      default: () => ([]),
      required: true
    },
    fsos: {
      type: Array,
      default: () => ([]),
      required: true
    }
  },

  emits: [
    'updated'
  ],

  data () {
    return {
      additional: 1,
      selected: {
        product: '',
        details: []
      },
      formPurchased: {
        total_amount: 0
      },
      tableMemos: {
        selected: {
          details: [],
          allSelected: false,
          indeterminate: false
        },
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        rows: this.details,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center min-w-25px' },
          { mobile: 1, key: 'selected', class: 'text-center min-w-50px' },
          { mobile: 2, key: 'officer', label: 'Technical Officer', class: { 'col-12 col-md-3': !this.isMobile() } },
          { mobile: 3, key: 'officer.clusters', label: 'Clusters', class: { 'col-12 col-md-2': !this.isMobile() } },
          { mobile: 4, key: 'customer', label: 'Customer', class: { 'col-12 col-md-87': !this.isMobile() } },
          { mobile: 6, key: 'action', class: 'text-center min-w-50px' }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  watch: {

    'tableMemos.selected.details' (details) {
      if (details.length === 0) {
        this.tableMemos.selected.indeterminate = false
        this.tableMemos.selected.allSelected = false
      } else if (details.length === this.tableMemos.rows.length) {
        this.tableMemos.selected.indeterminate = false
        this.tableMemos.selected.allSelected = true
      } else {
        this.tableMemos.selected.indeterminate = true
        this.tableMemos.selected.allSelected = false
      }
    },

    'details' (newDetails) {
      this.tableMemos.rows = newDetails
      this.tableMemos.selected.details = []
    }
  },

  methods: {

    updateFsoCluster (value, item) {
      if (value) {
        if (value?.clusters && value?.clusters?.length === 1) {
          item.cluster = value.clusters[0]?.id || null
        }
      } else {
        item.cluster = null
      }
    },

    tableRowRightClick (_product, _termIndex, event) {
      event.preventDefault()
    },

    filterOfficers (tradingMemo) {
      const customer = tradingMemo?.customer || null
      const officer = tradingMemo?.officer || null

      // get existing fso ids for the selected customer
      const fsos = this.tableMemos.rows.filter(
        rowMemo => {
          const { customer: rowCustomer, officer: rowFso } = rowMemo

          const isSameCustomer = String(rowCustomer?.customer_code) === String(customer?.customer_code)
          const isNotSameFso = String(rowFso?.id || '') !== String(officer?.id)

          return isSameCustomer && isNotSameFso
        }
      ).map(
        rowMemo => rowMemo?.officer?.id
      )

      const filterd = this.fsos.filter(
        option => (!fsos.includes(option?.id) &&
          Array.from(option?.clusters || [], cluster => cluster?.id).includes(customer?.cluster_id)
        ) || !customer?.cluster_id
      )

      return filterd
    },

    focusOnCustomerFSOfficer (_, quantityLocation) {
      const quantity = document.getElementById(`customer_memos.${quantityLocation}.quantity`)
      if (quantity) {
        quantity.focus()
      }
    },

    moveUpCustomerFSOfficer (_, quantityLocation) {
      this.focusOnCustomerFSOfficer(_, quantityLocation - 1)
    },

    moveDownCustomerFSOfficer (_, quantityLocation) {
      this.focusOnCustomerFSOfficer(_, quantityLocation + 1)
    },

    focusOnCustomerSelection (_, termIndex) {
      const customer = document.getElementById(`customer_memos.${termIndex}.customer`)
      if (customer) {
        customer.focus()
      }
    },

    focusOnNewMemo (_, termIndex) {
      const nextIndex = Number(termIndex) + 1

      if (this.tableMemos.rows.length === nextIndex) {
        this.addMemo(1)
      }

      setTimeout(() => {
        const hasNext = document.getElementById(`customer_memos.${nextIndex}.officer`)
        if (hasNext) {
          hasNext.focus()
        }
      }, 300)
    },

    addMemo (count = 5) {
      if (count > 25) {
        this.additional = 25
        return null
      }

      this.tableMemos.rows.push(
        ...Array.from({ length: Number(count) }, () => ({
          officer: null,
          cluster: null,
          customer: null
        }))
      )

      this.additional = 1
    },

    removeCustomer (_, termIndex, useFocus = false) {
      const validatedCustomers = this.tableMemos.rows.filter(
        (_, location) => Number(termIndex) !== Number(location)
      )

      if (validatedCustomers.length <= 0) {
        return this.swalInvalid('<h6>Form must have atleast 1 term</h6>', 'Removal Canceled')
      }

      if (validatedCustomers.length <= 1) {
        this.tableMemos.selected.details = []
      }

      this.tableMemos.rows = validatedCustomers

      if (useFocus) {
        this.focusOnCustomerSelection(_, (Number(termIndex) - 1))
      }

      this.$root.$emit('bv::hide::tooltip')

      this.$emit('updated', this.tableMemos.rows)
    },

    removeCustomers () {
      const validatedCustomers = this.tableMemos.rows.filter(
        (_, location) => !this.tableMemos.selected.details.includes(location)
      )

      if (validatedCustomers.length <= 0) {
        return this.swalInvalid('<h6>Form must have atleast 1 term</h6>', 'Removal Canceled')
      }

      this.tableMemos.rows = validatedCustomers

      this.tableMemos.selected.details = []

      this.$root.$emit('bv::hide::tooltip')
    },

    selectCustomer (_selectedCustomer, _termIndex) {
      // this.updated()
    },

    selectCustomers (selectAll) {
      this.tableMemos.selected.details = selectAll ? (
        this.tableMemos.rows.map((_, location) => location)
      ) : []
    },

    getCustomerMemos (schedule = '') {
      return this.tableMemos.rows.map(
        ({ customer, officer }) => ({
          schedule,
          customer_id: String(customer?.id),
          representative_id: String(officer?.id)
        })
      )
    },

    setErrors (errors) {
      if (this.$refs.formMemos) {
        this.$refs.formMemos.setErrors(errors)
      }
    },

    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.formMemos.validate().then(
          validMemo => {
            if (validMemo) {
              resolve(validMemo)
            } else {
              reject(validMemo)
            }
          }
        )
      })
    }
  }
}
</script>
